import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { binLabelFormatSchema } from "./print-bin-labels";

export const printStorageLocationLabels = {
  name: "printStorageLocationLabels" as const,
  input: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema).min(1).max(500),
    format: binLabelFormatSchema,
  }),
  output: z.object({ url: z.string() }),
};
